import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputAddress_suggestionsPopup: {
			zIndex: theme.zIndex.modal,
		},
		inputAddress_editLocationButton: {
			height: '1.2em',
			width: '1.2em',
		},
	});
});

export default useStyles;
